import { render, staticRenderFns } from "./CaseManagementDetail.vue?vue&type=template&id=df898486"
import script from "./CaseManagementDetail.vue?vue&type=script&lang=js"
export * from "./CaseManagementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports